import {
  PARTNER_LOGOS_CHANGE,
  PARTNER_LOGOS_EDIT_CHANGE,
  PARTNER_LOGOS_ADD,
  PARTNER_LOGOS_DELETE,
  PARTNER_LOGOS_GET,
  PARTNER_LOGOS_GET_ALL,
  PARTNER_LOGOS_RESET,
  SET_PARTNER_LOGOS_LOADING,
  SET_PARTNER_LOGOS_FORM_ERRORS,
  SET_PARTNER_LOGOS_FORM_EDIT_ERRORS,
} from './constants';

const initialFormData = {
  name: '',
  image: '',
  isEnabled: true,
};

const initialState = {
  partnerLogoFormData: { ...initialFormData },
  partnerLogosList: [],
  partnerLogosCount: 0,
  partnerLogo: {
    _id: '',
    isEnabled: true,
  },
  formErrors: {},
  editFormErrors: {},
  isLoading: false,
};

const partnerLogosReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_PARTNER_LOGOS_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      };
    case SET_PARTNER_LOGOS_FORM_ERRORS:
      return {
        ...state,
        formErrors: action.payload,
      };
    case SET_PARTNER_LOGOS_FORM_EDIT_ERRORS:
      return {
        ...state,
        editFormErrors: action.payload,
      };
    case PARTNER_LOGOS_CHANGE:
      return {
        ...state,
        partnerLogoFormData: {
          ...state.partnerLogoFormData,
          ...action.payload,
        },
      };
    case PARTNER_LOGOS_EDIT_CHANGE:
      return {
        ...state,
        partnerLogo: {
          ...state.partnerLogo,
          ...action.payload,
        },
      };
    case PARTNER_LOGOS_ADD:
      return {
        ...state,
        partnerLogosList: [...state.partnerLogosList, action.payload],
        partnerLogosCount: state.partnerLogosCount + 1,
      };
    case PARTNER_LOGOS_DELETE:
      return {
        ...state,
        partnerLogosList: state.partnerLogosList.filter(
          (partnerLogo) => partnerLogo._id !== action.payload
        ),
        partnerLogosCount: Math.max(0, state.partnerLogosCount - 1),
      };
    case PARTNER_LOGOS_GET:
      return {
        ...state,
        partnerLogo: { ...action.payload },
        editFormErrors: {},
      };
    case PARTNER_LOGOS_GET_ALL:
      return {
        ...state,
        partnerLogosList: action.payload || [],
        partnerLogosCount: (action.payload || []).length,
      };
    case PARTNER_LOGOS_RESET:
      return {
        ...state,
        partnerLogoFormData: { ...initialFormData },
        partnerLogo: { _id: '', isEnabled: true },
        formErrors: {},
        editFormErrors: {},
      };
    default:
      return state;
  }
};

export default partnerLogosReducer;
